export const VALIDATOR_URL = 'https://www.cian.ru/nd/validator/';
